<template lang="pug">
  .review(itemprop="review" itemscope itemtype="http://schema.org/Review").xs-f-small.md-f-medium.max-at-tweak
    meta(itemprop="itemReviewed" :content="review.productName")
    .hide(itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating")
      span(itemprop="ratingValue") {{ review.rating }}
      span(itemprop="bestRating") 5

    .review-info
      .name-info
        stars(:rating="review.rating")
        p(itemprop="author") {{ review.name }}
        template(v-if="review.city && review.state")
          p.name-info-item.color-slate Location: {{ review.city }}, {{ review.state }}
        p.name-info-label.color-slate(itemprop="datePublished" :content="review.review_date | moment('YYYY-MM-D')") {{review.review_date | moment('MMM D, YYYY') }}

      .comment
        h5(itemprop="name") {{ review.title }}
        p(show-more="200") {{ review.comment }}

        .helpful
          p(v-if="voted" role="alert").voted
            span.icon-check-nobox Thank you for your feedback!
          p(v-else)
            span Was this helpful?
            button.helpful-btn.color-purple(@click="voteOnReview(true)" data-mr-ass="helpful-yes") Yes ▲
            button.helpful-btn.color-purple(@click="voteOnReview(false)" data-mr-ass="helpful-no") No ▼

</template>

<script>
  import vueReviewSvc from '../../../services/vueReviewSvc';
  export default {
    name: "Review",
    props: {
      review: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        voted: false
      }
    },

    methods: {
      voteOnReview(helpful) {
        this.voted = true;

        let payload = {
          helpful,
          reviewId: this.review.id,
          productId: this.review.product_id
        };

        vueReviewSvc.voteForReview(payload);
      }
    }
  }
</script>

<style scoped lang="stylus">
  .review
    margin-bottom 2em

    .name-info
      width 70%

    .name-info-item
      text-transform capitalize

    h5
      font-family font-family-primary-semi-bold
      font-size 1.2em
      margin-bottom 0.8em

    .comment
      margin-top 1em

      .helpful-btn
        border 1px solid color-mr-purple
        padding 0.3em 0.5em
        margin 0.3em
        width 4em
        display inline-block
        text-align center
        background-color #fff

    .stars-right
      position absolute
      top 0
      right 1.5em
      padding-top 0.3em
      margin-bottom 0.7em

    .helpful
      margin-top 0.9em
      span
        margin-right 5px
        line-height 36px

      button
        margin 0 3px

    @media mq-tablet-plus
      .name-info
        display inline-block
        width 29%
        vertical-align top

      .comment
        display inline-block
        width 70%
        vertical-align top
        margin-top 0px

</style>